<mat-button-toggle-group
    class="transport-mode-toggle-group mb-4 flex w-full flex-wrap gap-2"
    [formControl]="formGroup.get('transportModes')"
    multiple
    aria-labelledby="trafficLabel">
    <mat-button-toggle class="mat-ripple text-sm" *ngFor="let value of values" [value]="value">
        <div
            class="var-app-light-dark:text-black toggle-content px-3"
            [class.uppercase]="!env.REMOVE_UPPERCASE"
            [class.capitalize]="env?.JOURNEY_PLANNER?.FILTERS?.CAPITALIZE_TRANSPORT_MODE_LABELS === true"
            (click)="itemClick($event, value)">
            {{ value | translate }}
        </div>
    </mat-button-toggle>
</mat-button-toggle-group>
